export class ResetProjectStorageList {
  public static readonly type =
    '[Project/Storage/List] ResetProjectStorageList';
}
